// extracted by mini-css-extract-plugin
export default {"heading":"ns-z","corrected":"os-z","redirectVerbiageContainer":"ps-z","redirectVerbiageText":"qs-z"};